import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-home-slide-nb-title',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        index: { type: Number, default: 0 },
        number: { type: String, default: '00' },
        label: { type: String, default: '' },
        color: { type: String, default: 'white' }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-nb-title/script.js